export default "__VITE_ASSET__BvgOAxTQ__"